export function getRandomArbitrary(min: number, max: number) {
  return Math.random() * (max - min) + min;
}
export function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
}